import produce from 'immer';
import {
  MAINTENANCE_CREATE,
  MAINTENANCE_DETAILS_REQUEST,
  MAINTENANCE_LIST_REQUEST,
  MAINTENANCE_REMOVE,
  MAINTENANCE_RESPONSE,
  MAINTENANCE_TERMINATE,
  MAINTENANCE_UPDATE, RESET_MAINTENANCE_DETAILS,
  SET_MAINTENANCE_DETAILS,
  SET_MAINTENANCE_LIST,
  SET_MAINTENANCE_PAGINATION
} from '../../constants/app/maintenanceConstants';

const initialState = {
  resultCode: null,
  code: '',
  description: '',
  page: 1,
  pageLength: 10,
  totalCount: 0,
  list: [
    {
      maintenanceNo: 0,
      title: '',
      isUrgent: true,
      startedAt: '',
      endedAt: ''
    }
  ],
  maintenanceNo: 0,
  title: '',
  content: '',
  isUrgent: true,
  startedAt: '',
  endedAt: '',
  createAt: '',
  maintenanceDetails: null,
};

const maintenanceReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case MAINTENANCE_LIST_REQUEST:
      break;
    case SET_MAINTENANCE_LIST:
      draft.list = action.list;
      break;
    case MAINTENANCE_TERMINATE:
      break;
    case MAINTENANCE_CREATE:
      break;
    case SET_MAINTENANCE_PAGINATION:
      draft.page = action.page;
      draft.pageLength = action.pageLength;
      draft.totalCount = action.totalCount;
      break;
    case MAINTENANCE_DETAILS_REQUEST:
      // MAINTENANCE_DETAILS_REQUEST 액션이 들어왔을 때, maintenanceDetails를 초기화.
      draft.maintenanceDetails = null;
      break;
    case SET_MAINTENANCE_DETAILS:
      draft.maintenanceDetails = action.info;
      break;
    case RESET_MAINTENANCE_DETAILS:
      // RESET_MAINTENANCE_DETAILS 액션을 처리하여 maintenanceDetails를 초기화.
      draft.maintenanceDetails = null;
      break;
    case MAINTENANCE_REMOVE:
      break;
    case MAINTENANCE_UPDATE:
      break;
    case MAINTENANCE_RESPONSE:
      draft.resultCode = action.resultCode;
      break;
    default:
      break;
  }
});

export default maintenanceReducer;
